import React from "react";
import { Link } from "react-router-dom";
import styles from "./Footer.module.scss";

const Footer = () => {
  const scrollToFAQ = () => {
    const faqSection = document.querySelector("#faq");
    if (faqSection) {
      faqSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  const scrollToAbout = () => {
    const aboutSection = document.querySelector("#about");
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  const scrollToContact = () => {
    const contactSection = document.querySelector("#contact");
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <div className="overflow-hidden w-full h-[6rem] bg-white flex items-center justify-center relative z-10">
        <div className="flex animate-marquee hover:[animation-play-state:paused]">
          {/* First Set */}
          <div className="flex min-w-full justify-around items-center gap-6 px-4">
            <img
              src="/Decoration.png"
              alt="carousel-icon"
              className="animate-spin-clock"
            />
            <div className={styles.carouselText}>Predictive Analysis</div>
            <img
              src="/Decoration.png"
              alt="carousel-icon"
              className="animate-spin-clock"
            />
            <div className={styles.carouselText}>Business Growth</div>
            <img
              src="/Decoration.png"
              alt="carousel-icon"
              className="animate-spin-clock"
            />
            <div className={styles.carouselText}>Smart Automation</div>
            <img
              src="/Decoration.png"
              alt="carousel-icon"
              className="animate-spin-clock"
            />
            <div className={styles.carouselText}>Strategic Planning</div>
            <img
              src="/Decoration.png"
              alt="carousel-icon"
              className="animate-spin-clock"
            />
            <div className={styles.carouselText}>Predictive Analysis</div>
            <img
              src="./Decoration.png"
              alt="carousel-icon"
              className="animate-spin-clock"
            />
            <div className={styles.carouselText}>Business Growth</div>
            <img
              src="/Decoration.png"
              alt="carousel-icon"
              className="animate-spin-clock"
            />
            <div className={styles.carouselText}>Smart Automation</div>
            <img
              src="/Decoration.png"
              alt="carousel-icon"
              className="animate-spin-clock"
            />
            <div className={styles.carouselText}>Strategic Planning</div>
          </div>
        </div>
      </div>

      <div class="flex items-end justify-center h-[24rem] md:h-[16rem] relative z-[2]">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="w-full max-w-[800px] h-auto"
          viewBox="0 0 800 200"
          fill="none"
        >
          <text
            x="50%"
            y="100%"
            text-anchor="middle"
            font-family="Arial, sans-serif"
            font-weight="bold"
            fill="#7584D6"
          >
            <tspan font-size="140">Vertik.ai</tspan>
          </text>
        </svg>
      </div>

      <section className={`${styles.footerContainer} md:flex-wrap`}>
        <div className={`${styles.company} sm:gap-0`}>
          <p className={styles.companyName}>Vertik.ai</p>
          <p className={styles.companyDescription}>
            Amplify your revenue with a Proactive AI Sales Companion.
          </p>
        </div>

        <div className={styles.stayInLoop}>
          <p className={styles.head}>Stay In The Loop</p>

          <div className={styles.emailField}>
            <p className={styles.detail}>Be first to know what's next</p>
            <div className={styles.emailInput}>
              <input type="email" placeholder="Your Email" />
              <img src="./RightArrow.png" alt="right-arrow" />
            </div>
          </div>
        </div>

        <div className={styles.column}>
          <p
            className={styles.columnText}
            onClick={scrollToFAQ}
            style={{ cursor: "pointer" }}
          >
            FAQ
          </p>
          <p
            className={styles.columnText}
            onClick={scrollToAbout}
            style={{ cursor: "pointer" }}
          >
            About Us
          </p>
          <Link to="/privacy-policy" className={styles.columnText}>
            Privacy Policy
          </Link>
          <Link to="/terms-of-service" className={styles.columnText}>
            Terms of Service
          </Link>
          <p
            className={styles.columnText}
            onClick={scrollToContact}
            style={{ cursor: "pointer" }}
          >
            Contact
          </p>
          <p className={styles.copyright}>Copyright © Vertik.ai 2025</p>
        </div>
      </section>
    </>
  );
};

export default Footer;
